import { InstitutionType } from 'types';
import { institutionTypeItems } from 'consts/institution/institutionType';

export const getInstitutionTypeLabel = (institutionType: InstitutionType) => {
    const selectedInstitutionTypeItem = institutionTypeItems.find(
        (institutionTypeItem) => institutionTypeItem.value === institutionType,
    );
    return selectedInstitutionTypeItem?.label || '';
};
